const accordionIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2073 5.44444H1.79268C1.65124 5.44444 1.53659 5.55223 1.53659 5.68518V15.3148C1.53659 15.4478 1.65124 15.5556 1.79268 15.5556H19.2073C19.3488 15.5556 19.4634 15.4478 19.4634 15.3148V5.68519C19.4634 5.55223 19.3488 5.44444 19.2073 5.44444ZM1.79268 4C0.802612 4 0 4.75448 0 5.68518V15.3148C0 16.2455 0.802611 17 1.79268 17H19.2073C20.1974 17 21 16.2455 21 15.3148V5.68519C21 4.75448 20.1974 4 19.2073 4H1.79268Z"
      fill="#6B00DF"
    />
    <path
      d="M0 1C0 0.447715 0.458635 0 1.02439 0H19.9756C20.5414 0 21 0.447715 21 1V1C21 1.55228 20.5414 2 19.9756 2H1.02439C0.458635 2 0 1.55228 0 1V1Z"
      fill="#6B00DF"
    />
    <path
      d="M0 20C0 19.4477 0.458635 19 1.02439 19H19.9756C20.5414 19 21 19.4477 21 20V20C21 20.5523 20.5414 21 19.9756 21H1.02439C0.458635 21 0 20.5523 0 20V20Z"
      fill="#6B00DF"
    />
  </svg>
);

const floatPanelAccordionIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2073 5.12195H11.0122C10.8708 5.12195 10.7561 5.23661 10.7561 5.37805V15.622C10.7561 15.7634 10.8708 15.878 11.0122 15.878H19.2073C19.3488 15.878 19.4634 15.7634 19.4634 15.622V5.37805C19.4634 5.23661 19.3488 5.12195 19.2073 5.12195ZM11.0122 3.58537C10.0221 3.58537 9.21951 4.38798 9.21951 5.37805V15.622C9.21951 16.612 10.0221 17.4146 11.0122 17.4146H19.2073C20.1974 17.4146 21 16.612 21 15.622V5.37805C21 4.38798 20.1974 3.58537 19.2073 3.58537H11.0122Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.89024 8.70732H1.79268C1.65124 8.70732 1.53659 8.82198 1.53659 8.96341V15.622C1.53659 15.7634 1.65124 15.878 1.79268 15.878H5.89024C6.03168 15.878 6.14634 15.7634 6.14634 15.622V8.96341C6.14634 8.82198 6.03168 8.70732 5.89024 8.70732ZM1.79268 7.17073C0.802612 7.17073 0 7.97334 0 8.96341V15.622C0 16.612 0.802612 17.4146 1.79268 17.4146H5.89024C6.88032 17.4146 7.68293 16.612 7.68293 15.622V8.96341C7.68293 7.97334 6.88032 7.17073 5.89024 7.17073H1.79268Z"
      fill="#6B00DF"
    />
    <path
      d="M0 1.02439C0 0.458635 0.458635 0 1.02439 0H19.9756C20.5414 0 21 0.458635 21 1.02439C21 1.59015 20.5414 2.04878 19.9756 2.04878H1.02439C0.458635 2.04878 0 1.59015 0 1.02439Z"
      fill="#6B00DF"
    />
    <path
      d="M0 4.60976C0 4.044 0.458635 3.58537 1.02439 3.58537H6.65854C7.22429 3.58537 7.68293 4.044 7.68293 4.60976C7.68293 5.17551 7.22429 5.63415 6.65854 5.63415H1.02439C0.458635 5.63415 0 5.17551 0 4.60976Z"
      fill="#6B00DF"
    />
    <path
      d="M0 19.9756C0 19.4099 0.458635 18.9512 1.02439 18.9512H19.9756C20.5414 18.9512 21 19.4099 21 19.9756C21 20.5414 20.5414 21 19.9756 21H1.02439C0.458635 21 0 20.5414 0 19.9756Z"
      fill="#6B00DF"
    />
  </svg>
);

export { accordionIcon, floatPanelAccordionIcon };
